import React from "react";

import {
    FiChevronLeft,
    FiChevronRight,
} from "react-icons/fi";

const LedgerPagination = ({
    page = 1,
    pageSize = 20,
    totalRecords = 0,
    totalPages = 1,
    pageSizeOptions = [
        10,
        20,
        50,
        100,
    ],
    onPageChange,
    onPageSizeChange,
}) => {
    const safePage =
        Math.max(
            Number(page) || 1,
            1
        );

    const safePageSize =
        Math.max(
            Number(pageSize) || 20,
            1
        );

    const safeTotalRecords =
        Math.max(
            Number(totalRecords) || 0,
            0
        );

    const safeTotalPages =
        Math.max(
            Number(totalPages) || 1,
            1
        );

    const startRecord =
        safeTotalRecords ===
            0
            ? 0
            : (
                safePage -
                1
            ) *
            safePageSize +
            1;

    const endRecord =
        Math.min(
            safePage *
            safePageSize,
            safeTotalRecords
        );

    const canGoPrevious =
        safePage >
        1;

    const canGoNext =
        safePage <
        safeTotalPages;

    return (
        <footer className="customer-ledger-pagination">
            <div className="customer-ledger-pagination-left">
                <span className="customer-ledger-pagination-info">
                    Showing{" "}
                    <strong>
                        {
                            startRecord
                        }
                    </strong>
                    {" - "}
                    <strong>
                        {
                            endRecord
                        }
                    </strong>
                    {" of "}
                    <strong>
                        {
                            safeTotalRecords
                        }
                    </strong>
                </span>

                <div className="customer-ledger-page-size">
                    <span>
                        Rows
                    </span>

                    <select
                        value={
                            safePageSize
                        }
                        onChange={(
                            event
                        ) =>
                            onPageSizeChange?.(
                                Number(
                                    event
                                        .target
                                        .value
                                )
                            )
                        }
                    >
                        {pageSizeOptions.map(
                            (
                                option
                            ) => (
                                <option
                                    key={
                                        option
                                    }
                                    value={
                                        option
                                    }
                                >
                                    {
                                        option
                                    }
                                </option>
                            )
                        )}
                    </select>
                </div>
            </div>

            <div className="customer-ledger-pagination-right">
                <button
                    type="button"
                    disabled={
                        !canGoPrevious
                    }
                    onClick={() =>
                        onPageChange?.(
                            safePage -
                            1
                        )
                    }
                >
                    <FiChevronLeft />

                    Previous
                </button>

                <span className="customer-ledger-page-indicator">
                    Page{" "}
                    <strong>
                        {
                            safePage
                        }
                    </strong>
                    {" of "}
                    <strong>
                        {
                            safeTotalPages
                        }
                    </strong>
                </span>

                <button
                    type="button"
                    disabled={
                        !canGoNext
                    }
                    onClick={() =>
                        onPageChange?.(
                            safePage +
                            1
                        )
                    }
                >
                    Next

                    <FiChevronRight />
                </button>
            </div>
        </footer>
    );
};

export default LedgerPagination;